export default __webpack_public_path__ + "assets/portugal-flag.png";